import React from "react";
import Router from "./Router";
import { AppInsightsContext, withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from './AppInsights';

function App() {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <Router />
    </AppInsightsContext.Provider>
  );
}

export default withAITracking(reactPlugin, App);